import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on every pathname change. If the URL has a hash,
// scroll to that element after a small delay so the target is mounted.
// The browser Back button's position restore is preserved by using
// window.scrollTo rather than touching history.scrollRestoration.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // small delay so the destination section mounts
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "instant", block: "start" });
        }
      }, 50);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
